<div class="container">

    <p>{{ nome_escola }}</p>

    <app-stepper [recebeAba]="aba"></app-stepper>

    <form [formGroup]="form">

        <div *ngIf="isLoading" class="loading">
            <mat-spinner></mat-spinner>
        </div>

        <mat-card class="card" *ngIf="isTerceiroAno()">
          <mat-card-content class="aviso_itinerario">
            <p class="aviso_itinerario__txt"><strong>Nota:</strong> Na compra do material do 3º ano do EM, favor optar por uma única área de Itinerário:</p>
    
            <section class="aviso_itinerario__opcoes">
              <!-- Opção 1 -->
              <div class="aviso_itinerario__opcao">
                <p class="aviso_itinerario__titulo">Opção 1 - Ciências Humanas</p>
                <ul class="aviso_itinerario__list">
                  <li *ngFor="let item of itens_humanas" class="aviso_itinerario__item">{{item}}</li>
                </ul>
              </div>

              <!-- Opção 2 -->
              <div class="aviso_itinerario__opcao">
                <p class="aviso_itinerario__titulo">Opção 2 - Ciências da Natureza</p>
                <ul class="aviso_itinerario__list">
                  <li *ngFor="let item of itens_natureza" class="aviso_itinerario__item">{{item}}</li>
                </ul>
              </div>
            </section>
          </mat-card-content>
        </mat-card>

        <mat-card class="card" *ngIf="!isLoading">
            <mat-card-content>
                <div class="container_table" *ngFor="let dependente of listaMateriais">
                    <div class="descricao_table">
                        <span class="txt txt_dependente"><strong>Aluno: </strong>{{dependente.nome_dependente}}</span>
                        <span class="txt txt_ano"><strong>Série: </strong>{{  dependente.serie.descricao }}</span>
                    </div>

                    <table mat-table *ngIf="dependente.produtos.length > 0; else mensagem" [dataSource]="dependente.produtos">
                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <!-- <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                                    </mat-checkbox> -->
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row); valoresProdutosSelecionados(); operacaoTotalPorDependente()" [checked]="selection.isSelected(row)">
                                </mat-checkbox>
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                            </td>
                        </ng-container>
                        <!-- Descrição do Produto -->
                        <ng-container matColumnDef="desc_produto">
                            <th mat-header-cell *matHeaderCellDef>Descrição</th>
                            <td mat-cell *matCellDef="let element"> {{element.desc_produto}} </td>
                            <td mat-footer-cell *matFooterCellDef>Total Aluno</td>
                        </ng-container>
                        <!-- Valor -->
                        <ng-container matColumnDef="preco">
                            <th mat-header-cell *matHeaderCellDef> Valor </th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.valor | currency:'BRL':'symbol':'1.2-2' }}
                            </td>
                            <td mat-footer-cell *matFooterCellDef>
                                <!-- Exibe o valor do dependente atual -->
                                {{ totalPorDependente[dependente.id_dependente] ? (totalPorDependente[dependente.id_dependente] | currency:'BRL':'symbol':'1.2-2') : 0 | currency:'BRL':'symbol':'1.2-2'}}
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row);"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                    </table>

                    <ng-template #mensagem>
                        <span class="mensagem">Não foram cadastrados itens para a série deste aluno.</span>
                    </ng-template>

                    <mat-divider></mat-divider>
                </div>

                <p class="txt txt_total"><strong>Total: </strong>{{ total | currency:'BRL':'symbol':'1.2-2'}}</p>

            </mat-card-content>

            <mat-card-actions>
                <button mat-button type="button" [routerLink]="'/dependente'"><mat-icon class="mat-18">arrow_back</mat-icon> VOLTAR</button>
                <button mat-raised-button color="primary" (click)="enviaListaMateriais()">CONTINUAR</button>
            </mat-card-actions>
        </mat-card>
    </form>
</div>